module.exports = __webpack_public_path__ + "static/img/28883542.813fee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/28883542.jpg
// module id = C4hD
// module chunks = 0